export const receiptCard_41 = {
    default: {
        backgroundColor: '#E31B22',
        color: '#fff',
        '& hr': {
            borderColor: '#B5151B',
        },
        '& a.link': {
            color: '#fff !important',
        }
    }
}